import { createLoadingSpinner } from '@vfde-brix/ws10/loading-spinner';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { mountComponent } from '../utils/mount';
import { AppId } from '../enums/elementId';

/**
 * Create Brix LoadingSpinner component.
 * @returns {LoadingSpinner | undefined} Loading Spinner
 * component or undefined if element with id is not found.
 */
export const mountLoadingSpinner = () =>
    mountComponent(
        AppId.LOADING_INDICATOR_CONTAINER,
        createLoadingSpinner,
        NO_PATTERN_BUSINESS_LOGIC
    );
